import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators'
import store from '@/store'
import CompanyBook from "@/model/CompanyBook";
import ActiveModule from './ActiveModule';
import {Inject} from "typescript-ioc";
import {LocalStorageWrapper} from "@/storage/StorageWrapper";
import StorageKey from "@/storage/StorageKey";

export abstract class CompanyBookModule implements ActiveModule<CompanyBook> {
    abstract active: CompanyBook;
    abstract activeOrNull: CompanyBook | null;

    abstract activate(t: CompanyBook): Promise<void>;

    abstract hasActive(): Promise<boolean>;

    abstract inactivate(): Promise<void>;

    abstract destroy(): Promise<void>
}

@Module({dynamic: true, namespaced: true, store, name: 'companyBook'})
class CompanyBookModuleImpl extends VuexModule implements CompanyBookModule {

    @Inject
    private storage!: LocalStorageWrapper

    private key = StorageKey.COMPANY_BOOK

    activeOrNull: CompanyBook | null = this.storage.getOrNull<CompanyBook>(this.key)

    get active(): CompanyBook {
        return this.activeOrNull ?? new CompanyBook()
    }

    @Action
    async activate(t: CompanyBook): Promise<void> {
        this.set(t)
        this.storage.set(this.key, t)
    }

    @Action
    async inactivate(): Promise<void> {
        this.remove()
        this.storage.remove(this.key)
    }

    @Action
    async hasActive(): Promise<boolean> {
        return this.activeOrNull != null
    }

    @Action
    async destroy(): Promise<void> {
        this.inactivate()
    }

    @Mutation
    private set(t: CompanyBook) {
        this.activeOrNull = t
    }

    @Mutation
    private remove() {
        this.activeOrNull = null
    }
}

const companyBookModule: CompanyBookModule = getModule(CompanyBookModuleImpl)
export default companyBookModule
